// external libs
import gsap from "gsap";
// owned libs
import BaseView from './base-view.js';
import ProjectUtil from '../utils/project-util.js';
import TrayExpand from '../utils/tray-expand.js';
import ScrollReveal from '../utils/scroll-reveal.js';
// video players
import VimeoPlayer from '../video/vimeo-player.js';
import YTPlayer from '../video/yt-player.js';
// views
import SliderView from './slider.js';
import HeaderBlockGallery from "./header-block-gallery.js";
import VerticalPostsList from './vertical-posts-list.js';
import PeopleListFilter from './people-list-filter.js';
import PostsListFilter from "./posts-list-filter.js";
import BottlesListFilter from "./bottles-list-filter.js";
import NewsletterSignup from "./newsletter-signup.js";
// template
//import template from '../../handlebars/client/page.hbs';


class PageView extends BaseView {
	el() { return '#container-main'; } // in footer 

	events() {
		return {
			//'click .yt-btn': 'handleYtBtnClick',
			//'click .slider-item-content .btn': 'handleYtBtnClick',
			//'click .production-item .media-btn': 'handleProductionMediaBtnClick',
			'click .expand-btn': 'handleExpandBtnClick',
			'click #edit-lista-btn': 'handleEditListaBtnClick',
		};
	}

	listeners() {
		this.listenTo(this.pubSub, 'scrollRevealRefresh', this.handleScrollRevealRefresh, this);
	}

	preRender() {
		// don't render this page if this is the initial page.
		if (ProjectUtil.initialPage === true) {
			this.renderPage = false;
			// render all additional pages
			ProjectUtil.initialPage = false;
			// perform actions outside of postRender, which will no longer work
			this.finishPageInit();
			//this.scrollToHash(false); // true to default to top
		} else {
			// new page - set page scroll to top
			//window.scrollTo(0, 0);
		}
	}

	setTemplate() {
		return import(/* webpackChunkName: "page" */ '../../handlebars/client/page.hbs')
			.then(templateModule => {
				this.template = templateModule.default;
			});
		//this.template = template;
	}

	hidePageLoader() {
		// dipatch hide loader event
		this.pubSub.trigger('hidePageLoader');
	}

	postRender() {
		this.finishPageInit();
		//this.scrollToHash(true); // true to default to top
		// show page
		gsap.to(this.$el, { duration: 0.3, alpha: 1, ease: 'quad.out' });
		return this;
	}

	finishPageInit() {
		/*const marqueeSliderConfig = {
			dispatchEvents: false,
			slidePosition: 'left',
			looping: true,
			autoPlay: true,
			useSwipe: false,
			columnSizingAr: [
				{
					minRes: 0,
					itemLeftPadding: 0,
					numColumns: 1,
					useArrows: false,
				},
			],
		};*/

		const postListImgGallerySliderConfig = {
			dispatchEvents: false,
			outerMargin: 0,
			looping: false,
			autoPlay: false,
			useArrows: true,
			columnSizingAr: [
				{
					minRes: 768,
					itemLeftPadding: 0,
					//holderLeftMargin: -20,
					numColumns: 1,
					useArrows: true,
				},
				{
					minRes: 0,
					itemLeftPadding: 0,
					//holderLeftMargin: -20,
					numColumns: 1,
					useArrows: true,
				},
			],
		};

		const socialSliderConfig = {
			dispatchEvents: false,
			outerMargin: 20,
			useArrows: false,
			columnSizingAr: [
				{
					minRes: 768,
					itemLeftPadding: 0,
					numColumns: 3,
					useArrows: true,
				},
				{
					minRes: 480,
					itemLeftPadding: 0,
					numColumns: 2,
					useArrows: true,
				},
				{
					minRes: 0,
					itemLeftPadding: 0,
					numColumns: 1,
					useArrows: true,
				},
			],
		};

		// build header blocks
		this.headerBlocks = [];
		document.querySelectorAll('.module.header-block.gallery').forEach(tEl => {
			const tView = new HeaderBlockGallery({ el: tEl, model: this.model });
			this.headerBlocks.push(tView);
			tView.render();
		});

		// build gallery sliders
		this.gallerySliders = [];
		/*// marquee
		document.querySelectorAll('.marquee-gallery.gallery-content').forEach(tEl => {
			this.gallerySliders.push(new SliderView({ el: tEl, model: this.model }).postRender(marqueeSliderConfig));
		});*/
		// standard
		document.querySelectorAll('.module.posts-list.standard .gallery-content').forEach(tEl => {
			const tView = new SliderView({ el: tEl, model: this.model });
			this.gallerySliders.push(tView);
			tView.postRender(socialSliderConfig);
		});
		// img-gallery
		document.querySelectorAll('.module.posts-list.img-gallery .gallery-content').forEach(tEl => {
			const tView = new SliderView({ el: tEl, model: this.model });
			this.gallerySliders.push(tView);
			tView.postRender(postListImgGallerySliderConfig);
		});

		this.verticalPostsLists = [];
		document.querySelectorAll('.module.posts-list.vertical-list:not(.right-column)').forEach(tEl => {
			const tView = new VerticalPostsList({ el: tEl, model: this.model });
			this.verticalPostsLists.push(tView);
			tView.postRender();
		});

		this.listFilters = [];
		document.querySelectorAll('.module.posts-list.filtered').forEach(tEl => {
			const tView = new PostsListFilter({ el: tEl, model: this.model });
			this.listFilters.push(tView);
			tView.postRender();
		});
		document.querySelectorAll('.module.people-list.filtered').forEach(tEl => {
			const tView = new PeopleListFilter({ el: tEl, model: this.model });
			this.listFilters.push(tView);
			tView.postRender();
		});
		document.querySelectorAll('.module.bottles-list').forEach(tEl => {
			const tView = new BottlesListFilter({ el: tEl, model: this.model });
			this.listFilters.push(tView);
			tView.postRender();
		});

		this.forms = [];
		document.querySelectorAll('.module.newsletter').forEach(tEl => {
			const tView = new NewsletterSignup({ el: tEl, model: this.model });
			this.forms.push(tView);
			tView.postRender();
		});


		// Build YouTube players
		this.buildYoutubePlayers();
		// Build Vimeo players
		this.buildVimeoPlayers(this);

		// trigger scrollReveal css animations
		$('body').addClass('ready');
		ScrollReveal.start();

		// dispatch render complete event
		this.pubSub.trigger('pageRenderComplete');
	}

	/*
	scrollToHash(defaultToTop) {
		const hash = window.location.hash;
		let targetTop;

		this.finishPageInit();

		// scroll to position (not on initialPage)
		// check hash to force scroll to specific module
		if (hash.length) {
			const $targetEl = document.querySelector(hash);
			if ($targetEl) {
				targetTop = $targetEl.offsetTop - 85; // don't align right to top
				setTimeout(() => {
					window.scrollTo(0, targetTop);
				}, 10);
			}
		} else if (defaultToTop) {
			window.scrollTo(0, 0);
		}
	}
		*/

	// Initialize Youtube Player
	buildYoutubePlayers() {
		const $youtubePlayerWraps = document.querySelectorAll('.yt-video-wrap');
		const players = [];
		const pauseVideos = (excludeID) => {
			players.forEach(player => {
				if (player.vidID !== excludeID && player.playstate === "playing") {
					player.pauseVideo();
				}
			});
		};
		const handleVideoPlaying = (vidID) => {
			// pause all videos except this newest one
			pauseVideos(vidID);
		};

		$youtubePlayerWraps.forEach((self) => {
			const $self = $(self);
			const $ytContainer = $('.yt-video-container', $self);
			const $videoPoster = $self.siblings('.video-poster');
			let ytID = '';

			// check for data-src
			if ($ytContainer.data('src')) {
				// attempt to get ytID
				ytID = YTPlayer.extractIdFromUrl($ytContainer.data('src'));
			}
			if (ytID !== '') {
				// store reference to ytID and poster
				$self.data('ytID', ytID);
				$self.data('poster', $videoPoster);
			} else {
				console.warn('REMOVING PLAYER - bad youtube url: ' + $ytContainer.data('src'));
				$self.parentElement.removeChild($self);
			}
		});

		// update reference - some elements may have been removed
		const updatedYoutubePlayerWraps = document.querySelectorAll('.yt-video-wrap');
		const totalPlayers = updatedYoutubePlayerWraps.length;

		updatedYoutubePlayerWraps.forEach((self, i) => {
			const $self = $(self);
			const $ytContainer = $('.yt-video-container', $self);
			const $videoPoster = $self.siblings('.video-poster');
			const ytID = $self.data('ytID');

			// instantiate new player
			const player = new YTPlayer();
			// initialize it
			player.initPlayer($ytContainer.data('dest'), ytID);
			// store reference
			$self.data('player', player);
			// load API (last player only)
			if (i === totalPlayers - 1 && !ProjectUtil.youtubeInitialized) {
				// Have the first Youtube Player load the API
				player.loadApi();
			}
			// store reference
			players.push(player);

			// store reference to this player for handling clicks

			$videoPoster.data('player', player);
			// handle clicks
			$videoPoster.on('click', (e) => {
				const $poster = $(e.currentTarget);
				const tPlayer = $poster.data('player');
				tPlayer.playVideo();
				$poster.classList.add('playing');
				gsap.to($poster, { duration: 0.3, autoAlpha: 0, ease: 'quad.inOut' });
			});

			// handle video events
			player.addEventListener('start', (vidID) => {
				handleVideoPlaying(vidID);
			});
			player.addEventListener('resume', (vidID) => {
				handleVideoPlaying(vidID);
			});
			player.addEventListener('end', () => {
				gsap.to($self.data('poster'), { duration: 0.3, autoAlpha: 1, ease: 'quad.inOut' });
			});
		});
	}

	buildVimeoPlayers(scope) {
		// ensure that Vimeo is loaded and ready
		if (!ProjectUtil.vimeoLoadRequested) {
			// Vimeo API has not been loaded
			ProjectUtil.vimeoInit();
			// set timeout to retry this function
			setTimeout(function () { scope.buildVimeoPlayers(scope); }, 100);
			return;
		}
		if (!ProjectUtil.vimeoReady) {
			// Vimeo API is not ready
			// set timeout to retry this function
			setTimeout(function () { scope.buildVimeoPlayers(scope); }, 100);
			return;
		}

		var self = scope,
			$vimeoPlayerWraps = $('.vimeo-video-wrap'),
			totalPlayers,
			player,
			players = [],
			/**
			 * When a video starts playing, pause all other videos
			 */
			handleVideoPlaying = function (vidID) {
				// pause all videos except this newest one
				self.pauseAllVideos('vimeo', vidID);
			};

		// parse the page for vimeo videos
		if ($vimeoPlayerWraps.length) {
			// there are videos, process them individually
			$vimeoPlayerWraps.each(function () {
				var $self = $(this),
					$vimeoContainer = $('.vimeo-video-container', $self),
					$videoPoster = $self.siblings('.video-poster'),
					$module = $self.closest('.module'),
					$videoDetailsWrap = $('.video-details-wrap', $module);
				if ($vimeoContainer.data('src')) {
					// store reference to videoUrl, poster, and detailsWrap
					$self.data({ videoUrl: $vimeoContainer.data('src'), $poster: $videoPoster, $detailsWrap: $videoDetailsWrap });
				} else {
					console.warn('REMOVING PLAYER - bad vimeo url: ' + $vimeoContainer.data('src'));
					$self.parent().remove();
				}
			});
			// update reference - some elements may have been removed
			$vimeoPlayerWraps = $('.vimeo-video-wrap');
			// store number of players for triggering the API load.
			totalPlayers = $vimeoPlayerWraps.length;
			// separate wrap - possibly different count
			$vimeoPlayerWraps.each(function (/*i*/) {
				var $self = $(this),
					$vimeoContainer = $('.vimeo-video-container', $self),
					$videoPoster = $self.siblings('.video-poster'),
					$videoDest = $('.vimeo-video-dest', $vimeoContainer),
					videoUrl = $self.data('videoUrl');

				// instantiate new player
				player = new VimeoPlayer();
				// initialize it
				player.initPlayer($vimeoContainer.data('dest'), videoUrl, { color: "#196583" });
				// store reference
				$self.data({ player: player, $dest: $videoDest });

				// store reference
				players.push(player);

				// store referenct to this player and video-dest for handling clicks
				$videoPoster.data({ player: player, $dest: $videoDest, $detailsWrap: $self.data('$detailsWrap') });

				// handle clicks
				$videoPoster.on('click', function (e) {
					var $poster = $(e.currentTarget),
						$videoBlock = $poster.closest(".module.video"),
						tPlayer = $poster.data('player'),
						$iframe = $('iframe', $poster.data('$dest'));
					// play the video
					tPlayer.playVideo();
					// make sure iframe has tabindex of 0 for focus
					$iframe.attr('tabindex', 0);
					// add 'playing' class to poster - don't know why
					$poster.addClass('playing');
					// update visibility of video - it's hidden to prevent Screen readers from interacting with video player UI
					$poster.data('$dest').css('display', 'block');
					// fade the poster out
					gsap.to($poster, { duration: 0.3, autoAlpha: 0, display: 'none', ease: 'power1.inOut' });
					if ($videoBlock.length) {
						$videoBlock.addClass('playing');
					}
					// add showing class to detailsWrap
					if ($poster.data('$detailsWrap') && $poster.data('$detailsWrap').length) {
						$poster.data('$detailsWrap').addClass('showing');
					}
					// accessibility - set focus on the iframe
					setTimeout(function () {
						//$iframe[0].contentWindow.focus();
						$iframe.focus();
					}, 300);

				});

				// handle video events
				player.player.on('play', function () {
					handleVideoPlaying(this._originalElement);
				});
				player.player.on('ended', function () {
					if ($self.data('$poster') && $self.data('$poster').length) {
						gsap.to($self.data('$poster'), { duration: 0.3, autoAlpha: 1, display: 'block', ease: 'power1.inOut' });
					}
					if ($self.data('$dest') && $self.data('$dest').length) {
						$self.data('$dest').css('display', '');
					}
				});
			});
		}
		scope.vimeoPlayers = players;
	}

	/**
	 * This is triggered either from a .yt-btn button, or from a click on a gallery row item button.
	 */
	/*handleYtBtnClick(e) {
		// if consent is not granted, this will open the youtube link in a new window.
		if (ProjectUtil.consentGranted) {
			// get the video id
			const ytID = YTPlayer.extractIdFromUrl(e.currentTarget.href);
			if (ytID) {
				// we parsed the Youtube Video ID, so show this in the modal instead of linking out
				e.preventDefault();
				e.stopPropagation();
				this.pubSub.trigger('requestVideoModal', { youtubeID: ytID });
			}
		}
	}
	*/
	/**
		 * Handle clicks on the main expand tray button
		 */
	handleExpandBtnClick(event) {
		var $tBtn = $(event.currentTarget), // get the button
			$expandWrap = $tBtn.siblings('.expand-tray'), // get the button's sibling '.expand-tray' element
			$contentTrayWrap = $tBtn.parent().parent(); // get two levels up - to force 'max-height:none' after expand is done

		// prevent bubbling
		event.preventDefault();
		event.stopPropagation();

		// make sure there is something to expand
		if ($expandWrap.length && $contentTrayWrap.length) {
			// if it's already expanded, then collapse it
			if ($contentTrayWrap.hasClass('showing')) {
				TrayExpand.collapse($expandWrap, $contentTrayWrap);

			} else {
				TrayExpand.expand($expandWrap, $contentTrayWrap);
			}
			$tBtn.toggleClass('showing');
		}
	}

	/**
	 * Handle scroll animation refresh
	 */
	handleScrollRevealRefresh() {
		// remove any listener
		ScrollReveal.stop();
		// start it again
		ScrollReveal.start();
	}

	/**
	 * Launch CMS in appropriate context
	 */
	handleEditListaBtnClick() {
		const page = this.model.get('page');
		let editURL = window.GlobalsObj.EDIT_PATH;
		if (page.edit.length > 0) { editURL += page.edit; }
		editURL += "&from-site=1";
		window.open(editURL);
	}

	// To be overwritten if you want some sort of 'hide' animation
	hide() {
		const self = this;
		gsap.to(this.$el, {
			duration: 0.4,
			alpha: 0,
			ease: 'quad.in',
			onComplete: () => {
				self.pubSub.trigger('viewHideComplete', this);
			}
		});
	}

	cleanup() {
		/*this.marqueefFadeViews.forEach(marquee => {
			marquee.destroy();
		});
		// kill gsap animations
		this.scrollAnimations.forEach(tAnim => {
			tAnim.kill();
		});*/
		// destroy gallery slider views
		this.gallerySliders.forEach(gallery => {
			gallery.destroy();
		});
		// destroy vertical posts lists
		this.verticalPostsLists.forEach(list => {
			list.destroy();
		});
		// destory list filters
		this.listFilters.forEach(list => {
			list.destroy();
		});
		// destroy header blocks
		this.headerBlocks.forEach(header => {
			header.destroy();
		});
		// destroy forms
		this.forms.forEach(form => {
			form.destroy();
		});
	}
}

export default PageView;